/* GIVELUNE v1: no checkout, analytics, uploads or simulated form submission. */
(() => {
  'use strict';
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
})();
